import { render } from "./ForcePasswordChange.vue?vue&type=template&id=1d16523e"
import script from "./ForcePasswordChange.vue?vue&type=script&lang=js"
export * from "./ForcePasswordChange.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appleuser/Documents/projets/complaints-management-crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__